import {detailServicesPath} from "../../Constants";
import axios from "axios";
import FileService from "../orders/orders/customer/FileService";

const restUrl = detailServicesPath + '/organizations/details-order/compositions'

export default class DetailCompositionController {
    static async get() {
        return axios.get(restUrl + '/for-composition', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async byModuleId(moduleId) {
        return axios.get(restUrl + '/by-module-id?moduleId=' + moduleId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async forRelateDetailModule(moduleId) {
        return axios.get(restUrl + '/for-relate-detail-module?moduleId=' + moduleId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async forRequestsCutting(requestsCuttingId, orderId) {
        return axios.get(
            restUrl + '/for-requests-cutting?requestsCuttingId=' + requestsCuttingId
            + '&orderId=' + orderId,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    static async save(data) {
        return await axios.post(restUrl + '/create-for-composition', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async upload(files, modelSeries, compositionMaterialType) {
        return await axios.post(restUrl + '/import/kdt?modelSeries=' + modelSeries + "&compositionMaterialType=" + compositionMaterialType,
            FileService.getFormDataArray(files, "file"), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }
}